import React from 'react';
import rangeMap from '@/lib/range-map';

import Skeleton from '@/components/v2/UI/Skeleton';

const SkeletonLoader = () => {
  return (
    <React.Fragment>
      {rangeMap(20, idx => (
        <Skeleton key={idx} className="w-full h-60 md:h-450 xl:h-500" />
      ))}
    </React.Fragment>
  );
};

export default SkeletonLoader;
